export const RELEASE_LINE = {
  angular: '6.1.x',
  packageVersion: '6.0.0',
  coreVersion: '0.1.1',
  runtimeTarget: 'Angular 6 + Angular CLI',
  docsPath: '/angular-6/'
};
